import {
  BookSelectorValue,
  BooksSelector,
} from 'components/forms/book-selector';
import { EditorState } from 'draft-js';
import { useInput } from 'lib/hooks/use-input';
import { useHasClickedOutside } from 'lib/hooks/use-has-clicked-outside';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { constants, getEntityIfSelected } from '../editor-utils';
import { CreateLink } from './link';

interface BookComponentProps {
  editorState: EditorState;
  setEditorState: Dispatch<SetStateAction<EditorState>>;
}
export const BookComponent = ({
  editorState,
  setEditorState,
}: BookComponentProps) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const book = useInput<BookSelectorValue[]>([]);
  const ref = useRef(null);
  const hasClickedOutside = useHasClickedOutside(ref);
  const alreadyHasBook = getEntityIfSelected(
    constants.EntityTypes.LINK,
    editorState
  );

  useEffect(() => {
    if (showModal && hasClickedOutside) {
      setShowModal(false);
      book.init([]);
    }
  });

  const handleCreateBook = () => {
    CreateLink(
      editorState,
      setEditorState,
      `/book/${book.value[0].data.isbn}`,
      'book'
    );
    setShowModal(false);
    book.init([]);
  };

  return (
    <>
      <div className='relative flex'>
        <button
          title='link'
          aria-label='link'
          className='bg-white hover:bg-gray-400 text-gray-800 font-semibold px-2 rounded disabled:text-gray-400'
          onClick={(e) => {
            e.preventDefault();
            setShowModal(true);
          }}
          disabled={!!alreadyHasBook}>
          <svg
            className='w-5 h-8'
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'>
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
            />
          </svg>
        </button>
        {showModal && (
          <div
            ref={ref}
            className='z-10 absolute right-0 mt-8 rounded-md  ring-1 ring-black ring-opacity-5 [ bg-white border border-gray-100 shadow-lg sm:rounded-lg px-1 py-2 sm:px-2 space-x-2 flex flex-row ] '>
            <BooksSelector
              value={book.value}
              setValue={book.setValue}
              limit={1}
            />
            <div className='flex rounded-md shadow-sm'>
              <button
                className='relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 disabled:cursor-not-allowed disabled:text-gray-500'
                onClick={handleCreateBook}
                disabled={!book.isModified}>
                <span>Link</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
